import React from "react";
import styled from "styled-components";
import { Row } from "antd";
import { Spacer } from "src/components/base";

interface SectionHeaderProps {
  title: string;
  subtitle: string;
  buttonText?: string;
  onButtonClick?: () => void;
  bp?: any; // Pass breakpoint if needed for responsive font sizes
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  buttonText,
  onButtonClick,
  bp = {},
}) => (
  <Row justify="space-between" align="middle" gutter={[0, 16]}>
    <div>
      <Title bp={bp}>{title}</Title>
      <Spacer height={16} />
      <SubTitle bp={bp}>{subtitle}</SubTitle>
    </div>
    {buttonText && onButtonClick && (
      <StyledButton onClick={onButtonClick}>
        {buttonText}
      </StyledButton>
    )}
  </Row>
);

const Title = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.homeHeading};
  ${({ theme }) => theme.styleGroup.body}
  font-size: ${(props: { bp; theme }) =>
    props.bp && props.bp.xs
      ? `${props.theme.fontSize.h3}px`
      : `${props.theme.fontSize.cardtitle}px`};
  line-height: 1;
  font-weight: 500;
`;

const SubTitle = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.homeBody};
  ${({ theme }) => theme.styleGroup.body}
  font-size: ${(props: { bp; theme }) =>
    props.bp && props.bp.xs
      ? `${props.theme.fontSize.bodyS}px`
      : `${props.theme.fontSize.bodyM}px`};
  font-weight: 400;
`;

const StyledButton = styled.button`
  border-radius: 8px;
  color: ${({ theme }) => theme.color.greySecondaryD};
  background-color: ${({ theme }) => theme.color.manorleadGold};
  font-family: ${({ theme }) => theme.fontFamily.homeBody};
  border: none;
  padding: 8px 24px;
  font-size: 16px;
  cursor: pointer;
  :hover {
    background-color: ${({ theme }) => theme.color.manorleadGold};
    color: ${({ theme }) => theme.color.greySecondaryD};
    filter: brightness(95%);
  }
`;
